import { Component, type ErrorInfo, type ReactNode } from "react";
import { ShibaTeacher } from "@/features/shiba-teacher";
import { Button } from "./Button";
import { track } from "@/lib/analytics";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    track("frontend_error", {
      message: error.message,
      stack: error.stack,
      componentStack: info.componentStack ?? undefined,
    });
  }

  handleReset = (): void => {
    if (typeof window !== "undefined") {
      window.location.replace("/");
    }
  };

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;
    return (
      <main className="min-h-dvh bg-cream flex flex-col items-center justify-center px-6 py-12">
        <ShibaTeacher expression="sad" size={160} />
        <h1 className="mt-6 text-2xl font-bold text-sumi">出错啦</h1>
        <p className="mt-2 text-sumi-soft text-center max-w-sm">
          页面发生了未知错误，回到首页重新试一下吧。
        </p>
        <Button className="mt-6" onClick={this.handleReset}>
          回到首页
        </Button>
      </main>
    );
  }
}
